import { min } from 'lodash';
import { Sheet, ShipGrowth, ShipUpgrade } from "@prometheus/types";
import { getShipMaxPopulation } from './getShipMaxPopulation';
import { calcQuest } from './calculateQuestBonus';
import { truncateCash } from './truncateCash';

export const getPopulationGrowth = (
  sheet: Sheet | undefined,
  upgrades: ShipUpgrade[],
  ship_growth: ShipGrowth[],
  turn?: number,
  messages?: string[]
) => {
  if (!sheet || !upgrades || !upgrades.length) {
    return 0
  }

  const quest_bonus = Math.round(calcQuest(sheet.quests.rewards.pop_growth_percentage || []) * sheet.population.count)
  const maxPop = getShipMaxPopulation(upgrades, sheet.population)
  for (const growth of ship_growth) {
    if (!(sheet.population.count >= growth.count)) {
      const new_pop = min([sheet.population.count + quest_bonus + growth.growth, maxPop]) || 0
      if (new_pop - sheet.population.count > 0) {
        if (typeof turn !== 'undefined' && turn < 30) {
          messages?.push(`Ship population has risen by ${truncateCash(new_pop - sheet.population.count, { raw: true })}.`)
        }
      } else {
        messages?.push(`Ship has reached your maximum ship population size of ${truncateCash(maxPop, { raw: true })}. Upgrade ship capacity to grow further!`)
      }
      return new_pop
    }
  }

  throw new Error('Should not reach here!')
}
